module.exports = __webpack_public_path__ + "static/media/13.93e406d6.JPG";